import React from "react";
import { observer, inject } from "mobx-react";
import { AddReview } from "ComponentsUI/Reviews";
import { graphql } from "@apollo/client/react/hoc";
import compose from "recompose/compose";
import { PROVIDERS_QUERY_FEEDBACK_PAGE, SPECIFICATIONS_QUERY } from "Services/queries";
import withDefaultParams from "Services/withDefaultParams";
import orderBy from "lodash/orderBy";
import { sendMetriks } from "Services/sendMetriks";
import { addAddressData, addABData, addRefererData } from "Utils";

@inject("ApplicationModel")
@observer
class AddReviewContainer extends React.Component {
	constructor(props) {
		super(props);
		let text = props.ApplicationModel.text;
		this.state = {
			reviewText: "",
			files: [],
			feedbackIsSended: false,
			negativeFeedback: null,
			ratings: null,
			openModal: true,
			timer: 100,
			tags: [
				{
					name: text.SEND_REVIEW_TAG_1,
					selected: false,
				},
				{
					name: text.SEND_REVIEW_TAG_2,
					selected: false,
				},
				{
					name: text.SEND_REVIEW_TAG_3,
					selected: false,
				},
				{
					name: text.SEND_REVIEW_TAG_4,
					selected: false,
				},
				{
					name: text.SEND_REVIEW_TAG_5,
					selected: false,
				},
				{
					name: text.SEND_REVIEW_TAG_6,
					selected: false,
				},
			],
			accepted: false,
			currentSlide: 0,
			choosenNetwork: null,
			provider: null,
			typeOfInternet: null,
			error: false,
			monthList: [
				{
					id: 1,
					name: "Меньше 3 месяцев",
				},
				{
					id: 2,
					name: "3 месяца - 1 год",
				},
				{
					id: 3,
					name: "1 год и больше",
				},
			],
			monthListValue: 0,
			serviceOfUseList: [
				{
					id: "internet",
					name: "Домашний интернет",
				},
				{
					id: "internet_tv",
					name: "Интернет и ТВ",
				},
				{
					id: "internet_mobile",
					name: "Интернет и мобильная связь",
				},
			],
			serviceOfUse: "",
		};
		this.wasInitialize = !props.ApplicationModel.providerModel.providerForFeedback;
	}

	reviewIsSendingNow = false;
	timerDescr = null;

	componentDidMount() {
		if (this.props.specifications && !this.state.ratings) {
			this.initRatings();
		}
	}

	addFile(event) {
		let newArray = this.state.files.slice();
		newArray.push(event.target.files[0]);
		this.setState({
			files: newArray,
		});
	}

	removeFile(index) {
		let newArray = this.state.files.slice();
		newArray.splice(index, 1);
		this.setState({
			files: newArray,
		});
	}

	scrollToTop() {
		let modalModel = this.props.ApplicationModel.modalModel;
		modalModel.scrollToTop(200, "html");
	}

	sendReview(callback) {
		if (!this.checkFirstPart()) {
			return;
		}
		if (!this.reviewIsSendingNow) {
			this.reviewIsSendingNow = true;
			let sendingStore = this.props.ApplicationModel.sendingStore;
			let text = this.props.ApplicationModel.text;

			let ratings = {};

			this.state.ratings.forEach((item, key) => {
				if (item.value) {
					ratings[`${key + 1}`] = item.value * 2;
				}
			});

			let tags = [];
			this.state.tags.forEach((item) => {
				if (item.selected) {
					tags.push(item.name);
				}
			});
			let data = {
				site_code: this.props.ApplicationModel.siteCode,

				order_type_id: this.state.typeOfInternet && this.state.typeOfInternet.id.toString(),
				technology_id: "2",

				short: "0",
				order_id: "0",
				review: this.state.reviewText,
				review_required: "1",

				provider_id: this.state.provider.id,
				provider: this.state.provider.name,
				provider_isset: "0",

				region_id: this.props.ApplicationModel.currentRegion.id,
				address_required: "0",

				not_rating: "0",
				specifications: JSON.stringify(ratings),
				timeofUse: this.state.monthListValue,
				servicesOfUse: this.state.serviceOfUse,

				tags: tags.join(";"),
				tags_synonym: "",
				tags_add_positive_input: "",
				tags_add_negative_input: "",
				phone: this.state.phone,
				not_want_leave_data: 0,
				notice_comment: "1",
				personal_data: "1",
				agree_with_rules: "1",
			};

			data = addAddressData(data, this.props.ApplicationModel);
			data = addABData(data);
			data = addRefererData(data, this.props.ApplicationModel);

			return sendingStore.onSendReview(data).then((data) => {
				this.reviewIsSendingNow = false;
				if (!data.errors) {
					this.setState({
						feedbackIsSended: true,
						timer: 8,
					});

					this.timerDescr = setInterval(() => {
						this.setState({
							timer: this.state.timer - 1,
						});
					}, 1000);

					// Metrika.getInstance().google.sendEvent(
					//     EVENT_CATEGORY_CLICK_BUTTON,
					//     EVENT_ACTION_CLICK_BUTTON_SEND_REVIEW
					// );
					sendMetriks("CLICK_FEEDBACK_BUTTON");
					callback();
				} else {
					this.setState({
						error: text.SOME_PROBLEM,
					});
				}
			});
		}
	}

	toggleTag(index) {
		let newArray = this.state.tags.slice();
		newArray[index].selected = !newArray[index].selected;
		this.setState({
			tags: newArray,
		});
	}

	changeModalValue() {
		this.setState({
			openModal: false,
		});
	}

	chooseMark(item, mark) {
		let ratings = this.state.ratings.slice();
		let negative = this.state.negativeFeedback;

		if (mark === 1 && !negative) {
			negative = ratings.filter((ratingItem) => ratingItem.name === item.name);

			this.setState({
				negativeFeedback: negative,
			});
		}

		ratings.forEach((ratingItem) => {
			let curNegative = negative ? negative[0] : false;
			if (curNegative) {
				if (ratingItem.name === curNegative.name) {
					ratingItem.negative = true;
				} else {
					ratingItem.negative = false;
				}
			}

			if (ratingItem.name === item.name)
				if (ratingItem.value !== mark) {
					ratingItem.value = mark;
				} else {
					ratingItem.value = 0;
				}
		});
		this.setState({
			ratings: ratings,
		});
	}

	reviewChanges(event) {
		this.setState({
			reviewText: event.target.value,
		});
	}

	selectProvider(provider) {
		this.setState({
			provider: provider[0],
		});
		if (!provider.length) {
			this.setState({
				typeOfInternet: null,
			});
		}
	}

	selectOrderType(type) {
		this.setState({
			typeOfInternet: type[0],
		});
	}

	changeCurrentSlide(value) {
		this.setState({
			currentSlide: value,
			error: false,
		});
	}

	checkRatings() {
		return (
			this.state.ratings.find((item) => item.value > 0) &&
			this.state.monthListValue > 0 &&
			!!this.state.serviceOfUse
		);
	}

	checkFirstPart() {
		if (
			!this.state.provider ||
			!this.state.typeOfInternet ||
			this.state.reviewText.length < 100 ||
			!this.checkRatings()
		) {
			return false;
		}
		return true;
	}

	setError(cb) {
		this.setState({
			error: true,
		});
		!!cb && cb();
	}

	checkCorrectAddress() {
		let searcheModel = this.props.ApplicationModel.searcheModel;
		return !searcheModel.checkErrors();
	}

	updateCallback() {
		this.forceUpdate();
	}

	componentWillUnmount() {
		clearInterval(this.timerDescr);
	}

	componentDidUpdate() {
		if (this.state.timer === 0) {
			clearInterval(this.timerDescr);
			this.props.closeHandler();
		}

		if (this.props.specifications && !this.state.ratings) {
			this.initRatings();
		}
		if (this.checkFirstPart() && this.state.error && this.state.currentSlide === 0) {
			this.setState({
				error: false,
			});
		}

		if (!this.wasInitialize) {
			let providerName = this.props.ApplicationModel.providerModel.providerForFeedback;
			if (!!this.props.providers) {
				let findedProvider = this.props.providers.data.find(
					(item) => item.url_name === providerName
				);
				if (!!findedProvider) {
					this.selectProvider([findedProvider]);
					this.wasInitialize = true;
					this.props.ApplicationModel.providerModel.setProviderFeedback(null);
				}
			}
		}
	}

	transformSpecs() {
		let ratings = this.props.specifications
			.filter((item) => {
				return item.id < 8;
			})
			.map((item) => {
				let newItem = JSON.parse(JSON.stringify(item));
				newItem.value = 0;
				return newItem;
			});
		ratings = orderBy(ratings, "id", "asc");
		return ratings;
	}

	initRatings() {
		let ratings = this.transformSpecs();
		this.setState({
			ratings,
		});
	}

	onClickButtonHandler(callback) {
		let authModel = this.props.ApplicationModel.newAuthModel;
		let userIsAuth = !!authModel.user && !!authModel.user.id;
		if (userIsAuth) {
			this.sendReview(callback);
		} else {
			let addButton = this.props.openRegistrationHandler();
		}
	}

	changeMonthValue(item) {
		this.setState({ monthListValue: item.id });
	}

	changeServiceOfUse(item) {
		this.setState({ serviceOfUse: item.id });
	}

	render() {
		let authModel = this.props.ApplicationModel.newAuthModel;
		let providers = this.props.providers ? this.props.providers.data : [];
		let userIsAuth = !!authModel.user && !!authModel.user.id;
		let text = this.props.ApplicationModel.text;
		let specifications = [];
		if (this.props.specifications) {
			specifications = this.transformSpecs();
		}
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		return (
			<AddReview
				h1={this.props.h1}
				text={text}
				windowSizes={windowSizes}
				removeFile={(index) => this.removeFile(index)}
				addFile={(e) => this.addFile(e)}
				sendReview={(callback) => this.sendReview(callback)}
				toggleTag={(index) => this.toggleTag(index)}
				chooseMark={(item, mark) => this.chooseMark(item, mark)}
				reviewChanges={(event) => this.reviewChanges(event)}
				checkFirstPart={() => this.checkFirstPart()}
				updateCallback={() => this.updateCallback()}
				checkCorrectAddress={() => this.checkCorrectAddress()}
				selectProvider={(provider) => this.selectProvider(provider)}
				setError={(cb) => this.setError(cb)}
				selectOrderType={(type) => this.selectOrderType(type)}
				providers={providers}
				changeCurrentSlide={(value) => this.changeCurrentSlide(value)}
				scrollToTop={() => this.scrollToTop()}
				userIsAuth={userIsAuth}
				onClickButtonHandler={(callback) => this.onClickButtonHandler(callback)}
				checkRatings={() => this.checkRatings()}
				data={this.state}
				specifications={specifications}
				urlToBack={this.props.url}
				closeHandler={this.props.closeHandler}
				changeMonthValue={(item) => this.changeMonthValue(item)}
				changeServiceOfUse={(item) => this.changeServiceOfUse(item)}
				changeModalValue={() => this.changeModalValue()}
				match={this.props.match}
			/>
		);
	}
}

export default withDefaultParams(
	compose(
		graphql(SPECIFICATIONS_QUERY, {
			props: ({ ownProps, data }) => {
				if (data.specifications && data.specifications.data) {
					return {
						...ownProps,
						specifications: data.specifications.data,
					};
				}
				return null;
			},
		}),
		graphql(PROVIDERS_QUERY_FEEDBACK_PAGE, {
			skip: (ownProps) => {
				return !ownProps.match.params.regionUrl;
			},
			options: (props) => {
				return {
					variables: {
						region: props.match.params.regionUrl,
					},
				};
			},
			props: ({ data }) => {
				return {
					providers: data.providersFeedback,
				};
			},
		})
	)(AddReviewContainer)
);
